module.exports = __webpack_public_path__ + "img/0Q3B5795_MockedUp.c11fdc45.jpg";